module.exports = __webpack_public_path__ + "static/Roof Tiling - 1-53041dbef29a533c346c5a7a9b103553.jpg";